(function ($) {
  
  //
  // Rating inputs
  //
  $(function () {
    var $ratingInputs = $('.mp-star-ratings-form input[name="rating"]');

    $ratingInputs.each( function() {
      var $ratingInput = $(this);
      $ratingInput.on('change', function() {
        var rating = $ratingInput.val();

        $ratingInputs.each( function($ratingInput) {
          var thisValue = $ratingInput.val();
          if (thisValue <= rating) {
            $ratingInput.addClass('active');
          } else {
            $ratingInput.removeClass('active');
          }
        });
      });
    });
  });

})(jQuery);
